var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9978 4.09277H7.33997C5.81087 4.09277 4.57129 5.33515 4.57129 6.86771V20.248C4.57129 21.7805 5.81087 23.0229 7.33997 23.0229H19.9978C21.5269 23.0229 22.7665 21.7805 22.7665 20.248V6.86771C22.7665 5.33515 21.5269 4.09277 19.9978 4.09277Z",
    stroke: "white",
    strokeWidth: 1.43905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4658 11.7305H17.5131",
    stroke: "white",
    strokeWidth: 1.43905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8252 15.3838H17.5134",
    stroke: "white",
    strokeWidth: 1.43905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissions);
export default __webpack_public_path__ + "static/media/missions.da5c8cc3b82e747b832293551199a109.svg";
export { ForwardRef as ReactComponent };